$(document).ready(function()
{
    $("#pagination-select").on('change', function(){
        value = $(this).val();
        window.top.location = value;
    });
});